export default {
  data: null,
  columns: [
    {
      label: '姓名',
      prop: 'memberName'
    },
    {
      label: '账号',
      prop: 'memberAccount'
    },
    {
      label: '会员类型',
      prop: 'memberLevelLabel'
    },
    {
      label: '定场目的',
      prop: 'placeOrderPurposeLabel'
    },
    {
      label: '场地属性',
      prop: 'typeLabel'
    },
    {
        label: '场号',
        prop: 'typeNumberLabel'
    },
    {
        label: '日期',
        prop: 'dateTime'
    },
    {
        label: '时间段',
        prop: 'dateRange'
    },
    {
        label: '状态',
        prop: 'statusLabel'
    },
    {
      label: '支付金额',
      prop: 'payAmount'
    },
    {
      label: '退款比例',
      prop: 'refundPercent'
    },
    {
      label: '退款金额',
      prop: 'refundAmount'
    }
  ]
}
